import React from 'react';
import { makeStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { Autocomplete } from '../../../Autocomplete';
import { useController, useFormContext } from 'react-hook-form';

const useStyles = makeStyles(styles);

const MultiSelect = ({
  // props for this component
  error,
  label,
  // disabledOnEdit,

  // props for Autocomplete
  options: opts,
  placeholder,
  isClearable,
  isFixed = false,
  disabled = false,
  // async,
  // defaultOptions,
  // loadOptions,
  // filterOption,

  // props for react-hook-form
  ...rhfProps
}) => {
  const classes = useStyles();

  const { control } = useFormContext();
  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    ...rhfProps,
    control,
  });
  const options = opts || [];

  return (
    <div className={classes.inputContainer}>
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          // disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          error && classes.textLabelError,
        )}
      >
        {label}: {!!error && error} <span>({options.length} options)</span>
      </p>

      

      <Autocomplete
        {...field}
        value={field.value ? options.filter(opt => field.value.includes(opt.value)) : []}
        options={options}
        menuPosition={isFixed ? "fixed" : "absolute"}
        onChange={opt => {
          const newValue = opt ? opt.map(o => o.value) : [];
          field.onChange(newValue);
        }}
        isClearable={isClearable}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        isMulti={true} // Always true for MultiSelect
        //
        // ASYNC stuff
        // async={async}
        // defaultOptions={defaultOptions}
        // loadOptions={loadOptions}
        //
        // additional props
        // filterOption={filterOption}
      />
    </div>
  );
};

export default MultiSelect; 